import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import DuNoNhanVayApi from "service/duNoNhanVayApi";
import { useSelector, useDispatch } from "react-redux";
import { getDate } from "utils/formatDate";
import { formatNumber } from "utils/currencyFormat";
import { BtnChiTietHopDong } from "../ChiTietHopDong/BtnChiTietHopDong";
import { BtnChiTietKhachhang } from "../ChiTietKhachHang/BtnChiTietKhachhang";
export const ModalChiTietSoNo = (props) => {
  useEffect(() => {
    console.log(props, "propspropspropspropspropsprops 111");
    DanhSachChiTiet();
  }, []);

  const dataInit = {
    List: [],
    TongDuNo: 0,
    TongBanGhi: 0,
  };
  const dataSearch = useSelector((state) => state.dataSearchDuNoNhanVay);

  const [dataChiTiet, UpdateDataChiTiet] = useState(dataInit);
  const [pageIndex, setPageIndex] = useState(1);
  const DanhSachChiTiet = () => {
    console.log(dataSearch, "nhan vay datasearch");
    DuNoNhanVayApi.getListChiTietDuNo1(
      dataSearch.dateFrom,
      dataSearch.dateTo,
      dataSearch.tenChuNo,
      props.nhanvien,
      dataSearch.mataisan,
      dataSearch.trangthai,
      dataSearch.sotienvay
    ).then((response) => {
      console.log(response.data, "1111");
      UpdateDataChiTiet({
        ...dataChiTiet,
        List: response.data.List,
        TongDuNo: response.data.TongDuNo,
        TongBanGhi: response.data.TongBanGhi,
      });
    });
  };

  const PhanTrang = (index) => {
    setPageIndex(index);
    DanhSachChiTiet(index);
  };

  const listItem = () => {
    return (
      dataChiTiet.List != null &&
      dataChiTiet.List.map((item, index) => {
        return (
          <tr>
            <th scope="row"> {index + 1 + (pageIndex - 1) * 20}</th>
            <td>
              <BtnChiTietHopDong item={item} />
            </td>
            <td>
              <BtnChiTietKhachhang item={item} />
            </td>
            <td>{getDate(item.NgayVay)}</td>
            <td>{getDate(item.NgayTra)}</td>
            <td className="text-right">
              <span className="color-do">{formatNumber(item.TotalMoney)}</span>
            </td>
          </tr>
        );
      })
    );
  };

  return (
    <Modal
      {...props}
      size="modal-xl modal-xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left popup-detail"
    >
      <Modal.Header>
        <h4 class="modal-title color7-bold" id="myModalLabel16">
          <span class="btn-icon-right">
            <i className="mdi mdi-bookmark-multiple-outline"></i>
          </span>
          Số dư nợ
        </h4>
        <button
          type="button"
          className="close-popup-new"
          onClick={props.onHide}
        >
          <i class="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <form className="form tat-toan form-horizontal">
          <div className="form-body">
            <div className="card collapse-icon accordion-icon-rotate">
              <div
                id="headingCollapse253128"
                className="card-header border-info"
                href="#collapse253128"
                aria-expanded="true"
                aria-controls="collapse25312"
              >
                <a className="card-title lead info collapsed">
                  <h3>Chi tiết dư nợ của: {props.nhanvien}</h3>
                </a>
              </div>
              <div
                id="collapse2531288"
                role="tabpanel"
                aria-labelledby="headingCollapse253128"
                className="card-collapse collapse show"
                aria-expanded="true"
              >
                <div className="card-content">
                  <div className="card-body">
                    <div className="Left-table">
                      <div className="table-responsive table-1">
                        <table className="table table-bordered mb-0 table-hover">
                          <thead>
                            <tr>
                              <th>
                                STT
                                <br />{" "}
                                <span className="color-do">
                                  [ {dataChiTiet.TongBanGhi} ]
                                </span>
                              </th>
                              <th>Mã nhận vay</th>
                              <th>Tên khách hàng</th>
                              <th>Ngày vay</th>
                              <th>Ngày trả</th>
                              <th className="text-right">
                                Số dư nợ
                                <br />
                                <span className="color-do">
                                  {formatNumber(dataChiTiet.TongDuNo)}
                                </span>
                              </th>
                            </tr>
                          </thead>
                          <tbody>{listItem()}</tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer className="modal-footer button-popup-new-size">
        <a
          className="btn btn-new-main btn-closenew"
          data-dismiss="modal"
          href={() => false}
          onClick={props.onHide}
        >
          <span className="btn-icon-left">
            <i className="mdi mdi-close"></i>
          </span>
          Đóng
        </a>
      </Modal.Footer>
    </Modal>
  );
};
